import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Anime%20manga%20style%20wide%20panoramic%20illustration%20of%20a%20dreamy%20cherry%20blossom%20landscape%20with%20soft%20pink%20and%20peach%20color%20gradient%20sky%20silhouette%20of%20a%20teenage%20boy%20standing%20on%20a%20hill%20looking%20at%20a%20beautiful%20sunrise%20or%20sunset%20glowing%20warm%20light%20floating%20petals%20and%20sparkles%20ethereal%20fantasy%20atmosphere%20Japanese%20anime%20background%20art%20style%20with%20soft%20cotton%20candy%20clouds%20cinematic%20wide%20shot%20warm%20and%20inviting%20mood%20simple%20beautiful%20composition&width=1920&height=1080&seq=pudding-hero-bg&orientation=landscape"
          alt="蜜桃少年漫画 - 布丁漫画网"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sparkling-line text-sm text-background-50"></i>
            </div>
            <span className="text-xs md:text-sm text-background-50 font-medium whitespace-nowrap">
              全新下拉式畅读体验
            </span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            蜜桃少年漫画
          </h1>
          <p className="text-sm md:text-lg text-background-50/90 max-w-xl mx-auto mb-8 leading-relaxed">
            免费阅读看下拉式漫画，在线下拉畅读全集中文故事<br className="hidden sm:block" />
            享受免费且流畅的浏览体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/article/comic-1"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-[0_4px_16px_rgba(0,0,0,0.15)]"
            >
              立即阅读
            </Link>
            <Link
              to="/category/shaonian-rexue"
              className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm md:text-base font-medium hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览全部漫画
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-10 flex-wrap">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">5000+</p>
              <p className="text-xs md:text-sm text-background-50/70">收录漫画</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">200万+</p>
              <p className="text-xs md:text-sm text-background-50/70">活跃读者</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">100%</p>
              <p className="text-xs md:text-sm text-background-50/70">免费阅读</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}